import React, { createContext, useState, useContext, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "./Table.css";
import "./common-style.css";
import "bootstrap/dist/css/bootstrap.css";
//Material
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Box from "@material-ui/core/Box";
//Function

const col = [
  {
    dataField: "id",
    text: "id",
    sort: true,
    //align: 'center',
    //events: onClickCol,
  },
  {
    dataField: "name",
    text: "Name",
    sort: true,
    //align: 'center',
    //events: onClickCol,
  },
];

const checkexistsId = (arr, id) => {
  return Array.isArray(arr) && arr.length && arr.find((el) => el.id === id);
};
const MyExportCSV = (props) => {
  const handleClick = () => {
    //props.onExport();
    //console.log(props?.totalData);
    props.onExport(props?.data?.filter(r => r.RECORD_ID = 1));
  };
  return (
    <div>
      <button className="btn btn-success" onClick={handleClick}>
        Export To CSV
      </button>
    </div>
  );
};

export const ReactBootStrapTable = ({
  id,
  clickToSelect = false,
  handleOnSelect,
  handleOnSelectAll,
  headcomponent = () => {
    return <></>;
  },
  exportCsv = false,
  selectOptions,
  tableReload,
  ...props
}) => {
  for (let index = 0; index < props.columns.length; index++) {
    props.columns[index] = {
      ...props.columns[index],
      sortCaret: (order) => {
        if (!order) return <ArrowDropUpIcon className="arrowDropIcon" />;
        else if (order === "asc") return <ArrowDropUpIcon />;
        else if (order === "desc") return <ArrowDropDownIcon />;
        return null;
      },
    };
  }

  const { SearchBar } = Search;
  const context = useContext(ReactTableContext);
  const [totolSizePerPage,setTotolSizePerPage] = useState(50);
  const [reload,setReload] = useState(tableReload);
  const selectRow = {
    mode: "checkbox",
    clickToSelect: false,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    style: { backgroundColor: "#c8e6c9" },
    ...selectOptions
  };
  useEffect(() => {
    setReload(tableReload);
}, [tableReload]);

  const customTotal = (from, to, size) => (
    
    <span className="react-bootstrap-table-pagination-total">
      Showing { reload ? 1:from } to { reload ? totolSizePerPage:to } of { size } Results
    </span>
  );
  const options = {
    onPageChange: (e,sizePerPage) => {
      setReload(false);
      // console.log(e);
      // console.log(sizePerPage);
      // console.log(totolSizePerPage);
      // if (checkexistsId(context.myProperties, id)) {
      //   let idx = context.myProperties.findIndex(
      //     (element) => element.id === id
      //   );
      //   let newArray = [...context.myProperties];
      //   newArray[idx] = { ...newArray[idx], page: e };
      //   context.setmyProperties(newArray);
      // } else {
      //   let newArray = [...context.myProperties].concat({ page: e, id });
      //   context.setmyProperties(newArray);
      // }
    },
    onSizePerPageChange: (e,page) => {
      //console.log(e);
      setTotolSizePerPage(e);
    },
    pageStartIndex: 0,
    
    //hideSizePerPage: true,
    totalSize: props?.totalData ?? props?.data?.length,
    sizePerPage:totolSizePerPage,
    // page:
    //   context &&
    //   context.myProperties.find((el) => el.id === id) &&
    //   context.myProperties.find((el) => el.id === id).page,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
      {
        text: "10000",
        value: 10000,
      },
    ],
    paginationTotalRenderer : customTotal,
    showTotal: true, // A numeric array is also available. the purpose of above example is custom the text
  };

  return (
    <>
      <ToolkitProvider
        keyField={props.keyField || "id"}
        data={props.data || []}
        columns={props.columns || col}
        bordered={false}
        search
      >
        {(innerprops) => (
          <div>
            <Box display="flex" flexDirection="row" alignItems="center">
              {/* <SearchBar {...innerprops.searchProps} /> */}
              <Box flexGrow={1}></Box>
              {headcomponent()}
              {exportCsv ? <MyExportCSV {...innerprops.csvProps} /> :null}
             
            </Box>

            {clickToSelect ? (
              <BootstrapTable
                {...innerprops.baseProps}
                {...props}
                selectRow={selectRow}
                noDataIndication="Data have 0 record"
                bodyStyle={{ wordBreak: "break-all" }}
                //onDataSizeChange={()=>{context.setmyProperties()}}
                pagination={paginationFactory(options)}
              />
            ) : (
              <BootstrapTable
                {...innerprops.baseProps}
                {...props}
                noDataIndication="Data have 0 record"
                bodyStyle={{ wordBreak: "break-all" }}
                //onDataSizeChange={()=>{context.setmyProperties()}}
                pagination={paginationFactory(options)}
                
              />
            )}
          </div>
        )}
      </ToolkitProvider>
      {/* {props.data && props.data.length} rows */}
    </>
  );
};
export const ReactTableContext = createContext();
export const ReactTableContextProvider = ({ children }) => {
  const [myProperties, setmyProperties] = useState([]);
  return (
    <ReactTableContext.Provider value={{ myProperties, setmyProperties }}>
      {children}
    </ReactTableContext.Provider>
  );
};
ReactBootStrapTable.propTypes = {};
export default ReactBootStrapTable;
